/* =========
Trying to maintain accessibility for keyboard
users and appease designers
========== */
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        // Add class to body to show user is tabbing
        document.body.classList.add('user-is-tabbing');
        // Remove the event listener for keydown events
        window.removeEventListener('keydown', handleFirstTab);
        // Add event listener for mousedown events
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    // Remove the user is tabbing body class
    document.body.classList.remove('user-is-tabbing');
    // Remove the event listener for mousedown events
    window.removeEventListener('mousedown', handleMouseDownOnce);
    // Add event back for keydown events
    window.addEventListener('keydown', handleFirstTab);
}
// Set intial event listener for keydown events
window.addEventListener('keydown', handleFirstTab);

// Remove no-js class
document.querySelector('html').classList.remove('no-js');

/* =========
Helper function to determine if an element is within the viewport
========== */
function inViewport(elem) {
    let bounding = elem.getBoundingClientRect(),
        offset = elem.clientHeight / 2;
    return (
        bounding.top <= (window.innerHeight || document.documentElement.clientHeight) - offset &&
        bounding.bottom >= offset
    );
}

/* =========
Helper function to scroll the viewport to a specific element
========== */
function scrollToElement(elem, offset = 0) {
    const y = elem.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({top: y, behavior: 'smooth'});
}

// Remove, just used for the scroll back to top on the template cutups
const backToTop = document.querySelector('.backtotop');
if(backToTop) {
    backToTop.addEventListener('click', event => {
        window.scrollTo({top: 0, behavior: 'smooth'});
        event.preventDefault();
    });
}